<template>
  <div
    ref="modalEl"
    class="modal fade"
    id="viewOpeningBalanceModal"
    tabindex="-1"
  >
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Opening Balance</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
          ></button>
        </div>

        <div class="modal-body">
          <div v-if="loading" class="text-center text-muted py-4">
            <i class="bi bi-hourglass-split me-2"></i>Loading…
          </div>

          <div v-else-if="error" class="alert alert-danger">
            {{ error }}
          </div>

          <div v-else-if="!opening" class="alert alert-warning mb-0">
            Opening balance not found for this member.
          </div>
          <div v-else>
            <div class="mb-3">
              <div class="text-muted small">Member</div>
              <div class="fw-semibold">{{ member?.name }}</div>
            </div>

            <div class="row g-3">
              <div class="col-6">
                <div class="text-muted small">Amount</div>
                <div class="fw-bold">
                  {{ Number(opening.amount || 0).toLocaleString() }}
                </div>
              </div>

              <div class="col-6">
                <div class="text-muted small">As-of period</div>
                <div class="fw-semibold">
                  {{ opening.as_of_period || "—" }}
                </div>
              </div>
            </div>

            <div v-if="opening.note" class="mt-3">
              <div class="text-muted small">Note</div>
              <div>{{ opening.note }}</div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/services/http";
import { Modal } from "bootstrap";

export default {
  name: "ViewOpeningBalanceModal",

  data() {
    return {
      modal: null,
      loading: false,
      error: "",
      member: null,
      opening: null,
    };
  },

  methods: {
    async open(member) {
      this.member = member;
      this.loading = true;
      this.error = "";
      this.opening = null;

      this.modal.show();

      try {
        const res = await http.get(`/opening-balances/user/${member.id}`);
        this.opening = res?.data?.data || null;
      } catch (e) {
        this.error =
          e?.response?.data?.message || "Failed to load opening balance.";
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    const el = this.$refs.modalEl;
    if (!el) return;
    this.modal = new Modal(el);
  },
};
</script>
